// Embedded previews and privacy modes may forbid storage. The 3D experience
// must still load; successful saves remain accessible through their server IDs.
const sessionMemory = new Map();
export const readStorage = key => {
  try { return window.localStorage.getItem(key) || sessionMemory.get(key) || null; }
  catch { return sessionMemory.get(key) || null; }
};
export const writeStorage = (key, value) => {
  sessionMemory.set(key, value);
  try { window.localStorage.setItem(key, value); return true; }
  catch { return false; }
};